import axios from 'axios'
import qs from 'qs'

// import store from '@/store'
import { Toast,Dialog } from 'vant'
// 根据环境不同引入不同api地址
import { baseApi } from '@/config'
import store from '@/store'
import { getToken, removeStorage } from './storage'
import router from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: baseApi, // url = base api url + request url
  withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
})

let message = false
// request拦截器 request interceptor
service.interceptors.request.use(
  config => {
    if (config.method === 'post') {
      config.data = qs.stringify(config.data,{indices:false})
    }
    // 不传递默认开启loading
    if (!config.hideloading) {
      // loading
      Toast.loading({
        forbidClick: true
      })
    }
    if (getToken()) {
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)
// respone拦截器
service.interceptors.response.use(
  response => {
    Toast.clear()
    const res = response.data

    if (res.code == 1) {
      message = false
      return Promise.resolve(res)
    } 
    else if (res.code == 401) {// 重新登录
      if (!message) {
        message = true
        removeStorage("token");
        router.replace({ path: '/login' })
      }
    } else if (res.code == 103 || res.code == 104 || res.code == 106) {//103 会员已过期,104 非正式会员，关注人数超过3人,106 会员状态为禁用，或者会员类型为非会员
      message = false
      return Promise.reject(res || 'error')
    } else if (res.code == 105) {//分享中，用户已过期
      message = false
      router.replace({ path: '/error/expired' })
    } else {
      message = false
      setTimeout(() => {
        Toast({
          message: res.msg,
          position: 'bottom'
        })
      },100)
      return Promise.reject(res || 'error')
    }
  },
  error => {
    Toast.clear()
    if (error.response) {
      console.log("请求错误");
        switch (error.response.status) {
            case 401:
                removeStorage("token");
                router.replace({path: '/login'})
                break;
            case 411:
                removeStorage("registration-token")
                router.replace({path: '/h5registration/login'})
                break;
            case 412:
                router.replace({path: '/h5registration/information'})
                break;
        }
    }

    return Promise.reject(error)
  }
)

export default service
